module.exports = __webpack_public_path__ + "img/plus.c101daf4.svg";